var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IndustrialPropertyFormEditor',{attrs:{"form-name":"modifyIndustrialPropertyForm","modification":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }